import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'

import ChartInvestor from 'Component/chart/investor'
import { formatDate } from 'Util';
import InvestorSummary from 'Component/stock/investor_summary';
import SubHead from 'Component/title/sub_head';

const Investor = () => {

  const { tickerDetail } = useSelector((state) => state.stock);
  const [data, setData] = useState();
  
  useEffect(() => {
    if (tickerDetail && tickerDetail.iv_history && tickerDetail.iv_history.length > 0) {
      const x = [];
      const y1 = [];
      const y2 = [];

      let list = [...tickerDetail.iv_history];
      list = list.reverse();
      list.forEach(element => {
        x.push(formatDate(element.TRD_DT));
        y1.push(element.INSTITUTION_SUPPLY/1000000);
        y2.push(element.FOREIGN_SUPPLY/1000000);
      });

      setData({
        x: x,
        y1: y1,
        y2: y2,
      })
    } else {
      setData(null);
    }
  }, [tickerDetail])

	return (
    <div className="content8">
      <SubHead>
        <img src="/static/images/icon_build2.png" alt="" />
        <span>외인/기관 수급동향</span>
      </SubHead>
      <div className="cont">
        <div className="tip">기관 및 외국인 매매 동향은 주가에 어떤 영향을 미치고 있는지 확인해 보세요!</div>
        <div className="chart chart1">
          { data &&
            <ChartInvestor data={data} title={['기관누적', '외국인누적']} />
          }
        </div>
        { tickerDetail && tickerDetail.iv &&
          <InvestorSummary data={tickerDetail.iv} />
        }
      </div>
    </div>
  );
}

export default Investor;
